import { Body14Regular } from "@/components/typography/Body14Regular";
import { departmentService } from "@/services/department-service";
import { DepartmentDto } from "@/types/dto/department-dto";
import { UserDto } from "@/types/dto/user-dto";
import { Select, Table, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { CustomCell } from "../CustomCell";

interface Props {
  user: UserDto;
  phone: string;
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  departmentId: number;
  handleDepartmentChange: (departmentId: number) => void;
}

export const AdminMyDetailTable: React.FC<Props> = ({
  user,
  phone,
  departmentId,
  handlePhoneChange,
  handleDepartmentChange,
}) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";

  const [departments, setDepartments] = useState<DepartmentDto[]>([]);

  const getDepartment = async () => {
    const response = await departmentService.getPage({ page: 1, size: 100 });
    setDepartments(response.data.contents);
  };

  useEffect(() => {
    getDepartment();
  }, []);

  return (
    <div className="overflow-x-auto rounded-lg border">
      <Table>
        <Table.Body>
          <Table.Row className="border-b border-gray-200">
            <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  관리자명
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <CustomCell>
                <Body14Regular className="text-semantic-text-body">
                  {user.name}
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell
              className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
            >
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  연락처
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="px-[6px] w-[680px] h-[52px] bg-primary-white">
              <TextInput
                color="white"
                placeholder="연락처를 입력해주세요"
                value={phone}
                onChange={handlePhoneChange}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row className="border-b border-gray-200">
            <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  이메일
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <CustomCell>
                <Body14Regular className="text-semantic-text-body">
                  {user.email}
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell
              className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
            >
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  부서
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <Select
                className="w-full m-0 py-0 px-[6px]"
                color="white"
                value={departmentId}
                onChange={(e) => {
                  handleDepartmentChange(Number(e.target.value));
                }}
              >
                <option key={0} value={0}>
                  부서를 선택해주세요.
                </option>
                {departments.map((department) => (
                  <option key={department.id} value={department.id}>
                    {department.name}
                  </option>
                ))}
              </Select>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};
